/* Contact Sales modal — Asana 1216754975045925.
   HubSpot v4 embeds render in a cross-origin iframe, so the form is only reachable
   through window.HubSpotFormsV4 + the hs-form-event:on-ready event. */
(function () {
  /* VERIFIED: the full property reference is required. The bare name 'product_to_quote'
     fails SILENTLY — no error, no effect. Do not shorten this. */
  var FIELD_NAME = '0-1/product_to_quote'; /* hidden CRM field, added by HubSpot 2026-08-17.
     Replaces the earlier inquiry_question prefill: the Message box belongs to the customer,
     and this field is structured and reportable in HubSpot. */
  var config = window.contactSalesConfig || {};
  var modal = document.getElementById('pdp-contact-sales');
  if (!modal) return;

  var embedLoaded = false;
  var prefillMessage = '';
  var lastFocused = null;

  function selectedVariantId() {
    /* main-product renders this hidden input */
    var input = document.getElementById('pdp-form-variant-id');
    if (input && input.value) return parseInt(input.value, 10);
    /* main-product-fbs has no such input — its configurator keeps the selected variant in
       `let pdpSelectedVariant` (main-product-fbs.liquid:364), a top-level binding in a
       classic script. That is a global LEXICAL binding: reachable by bare name, never on
       window. Guarded because it is undefined on every other template. */
    try {
      if (typeof pdpSelectedVariant !== 'undefined' && pdpSelectedVariant && pdpSelectedVariant.id) {
        return parseInt(pdpSelectedVariant.id, 10);
      }
    } catch (e) { /* not declared on this template */ }
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function currentContext() {
    var id = selectedVariantId();
    var index = id ? (config.variants || []).indexOf(id) : -1;
    var sku = index > -1 ? config.variantSkus[index] : '';
    if (!sku) {
      try {
        if (typeof pdpSelectedVariant !== 'undefined' && pdpSelectedVariant && pdpSelectedVariant.sku) {
          sku = pdpSelectedVariant.sku;
        }
      } catch (e) { /* not declared on this template */ }
    }
    /* Coerce null/undefined to ''. Shopify returns null for an unset SKU, and
       Array.prototype.join stringifies that to the literal "null" — which would
       otherwise reach a salesperson as "SKU null". Moxie's variants have no SKUs
       at all, so this is a real catalog state, not a hypothetical. */
    return {
      product: config.productTitle || '',
      variant: (index > -1 ? config.variantTitles[index] : '') || '',
      sku: sku || ''
    };
  }

  /* Placeholders use SINGLE braces. Double braces are Liquid output syntax — written
     that way inside a .liquid file they are interpolated server-side and never reach
     the browser ({product} became "ProductDrop"). Do not "restore" double braces.
     Global replace: the template is a merchandiser-editable setting, so a placeholder
     may legitimately appear more than once. */
  function buildProductToQuote() {
    var ctx = currentContext();
    return (config.messageTemplate || '')
      .split('{product}').join(ctx.product)
      .split('{variant}').join(ctx.variant)
      .split('{sku}').join(ctx.sku);
  }

  function loadEmbed() {
    if (embedLoaded) return;
    embedLoaded = true;
    var script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/' + config.portalId + '.js';
    script.defer = true;
    document.head.appendChild(script);
  }

  /* Write ONCE, on ready. Field is hidden, but the event is global and fires for
     any HubSpot form on the page, and can re-fire — a second write is redundant
     at best and a race against HubSpot's own state at worst. The latch below is
     what ENFORCES the single write; we also confirm the event belongs to our
     form (getFormId) before touching it. This does NOT touch 0-1/inquiry_question
     (the visible Message box) — that field is the customer's, untouched. */
  var prefillWritten = false;

  document.addEventListener('hs-form-event:on-ready', function (event) {
    if (prefillWritten || !prefillMessage) return;
    if (!window.HubSpotFormsV4 || !window.HubSpotFormsV4.getFormFromEvent) return;
    var form = window.HubSpotFormsV4.getFormFromEvent(event);
    if (!form || typeof form.setFieldValue !== 'function') return;
    /* Only our form. getFormId() is synchronous and returns the form GUID. */
    if (typeof form.getFormId === 'function' && config.formId && form.getFormId() !== config.formId) return;
    form.setFieldValue(FIELD_NAME, prefillMessage);
    prefillWritten = true;
  });

  function open() {
    lastFocused = document.activeElement;
    prefillMessage = buildProductToQuote();
    modal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var main = document.getElementById('main');
    if (main) main.setAttribute('aria-hidden', 'true');
    loadEmbed();
    var close = modal.querySelector('.pdp-contact-sales__close');
    if (close) close.focus();
  }

  function close() {
    modal.removeAttribute('open');
    document.body.style.overflow = '';
    var main = document.getElementById('main');
    if (main) main.removeAttribute('aria-hidden');
    if (lastFocused) lastFocused.focus();
  }

  document.querySelectorAll('[data-contact-sales-open]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  modal.querySelectorAll('[data-contact-sales-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.hasAttribute('open')) close();
  });

  /* Focus trap */
  modal.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = modal.querySelectorAll('button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
